var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-form" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.ready,
            expression: "ready"
          }
        ]
      },
      [
        _vm._l(_vm.bookingForm.travellers, function(traveller, key) {
          return _c("booking-traveler", {
            key: key,
            attrs: {
              number: _vm.travellerNumber[key],
              editMode: _vm.editMode,
              value: _vm.bookingForm.travellers[key]
            },
            on: {
              input: function(val) {
                return _vm.onUpdateTraveller(val, key)
              },
              valid: function(valid) {
                return _vm.$set(_vm.isValid.travelers, key, valid)
              },
              edit: _vm.gotoEditMode
            }
          })
        }),
        _vm._v(" "),
        _c("booking-order-details", {
          attrs: {
            comment: _vm.userComment,
            newsletter: _vm.bookingForm.subscribeCustomerToNewsletter,
            editMode: _vm.editMode,
            value: _vm.bookingForm.customer
          },
          on: {
            input: _vm.onUpdateOrderDetails,
            comment: function(comment) {
              return (_vm.userComment = comment)
            },
            newsletter: function(newlsetterSignup) {
              return _vm.$set(
                _vm.bookingForm,
                "subscribeCustomerToNewsletter",
                newlsetterSignup
              )
            },
            valid: function(valid) {
              return _vm.$set(_vm.isValid, "orderDetails", valid)
            },
            validOfferCode: function(validCode) {
              return (_vm.validOfferCode = validCode)
            },
            edit: _vm.gotoEditMode
          }
        }),
        _vm._v(" "),
        _c("booking-payment-details", {
          attrs: {
            editMode: _vm.editMode,
            changes: _vm.changeList,
            acceptChanges: _vm.customerAcceptsChanges
          },
          on: {
            acceptChanges: function(val) {
              return (_vm.customerAcceptsChanges = val)
            },
            userConsentedPrice: function() {
              return _vm.$emit("userConsentedPrice")
            },
            valid: function(valid) {
              return (_vm.isValid.bookingPaymentDetails = valid)
            },
            edit: _vm.gotoEditMode
          },
          model: {
            value: _vm.bookingForm.terms,
            callback: function($$v) {
              _vm.$set(_vm.bookingForm, "terms", $$v)
            },
            expression: "bookingForm.terms"
          }
        }),
        _vm._v(" "),
        _vm.editMode || _vm.loadingPayment
          ? _c("button", {
              staticClass: "btn btn--positive pay-travel-button",
              class: { "item-loading": _vm.loadingPayment },
              attrs: { disabled: !_vm.fieldsAreValid || _vm.loadingPayment },
              domProps: {
                textContent: _vm._s(_vm.translations.pay_travel_button)
              },
              on: { click: _vm.gotoPayment }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.editMode
          ? _c("booking-payment", {
              attrs: { customer: _vm.bookingForm.customer },
              on: {
                paymenttokens: function(paymentTokens) {
                  return (_vm.bookingForm.paymentTokens = paymentTokens)
                },
                booktravel: _vm.doBooking,
                ready: function($event) {
                  _vm.paymentReady = true
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "rejsegarantiordning-btn",
            attrs: {
              href: "https://www.skovrejser.dk/rejsegarantiordning",
              target: "_blank"
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "rejsegarantiordning-btn__icon",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 521.39 521.39"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "m260.69,346.03c12.22,0,29.41-33.05,31.57-85.33h-63.15c2.16,52.29,19.35,85.33,31.57,85.33Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m165.77,239.36h41.81c1.18-29.06,7.18-57.95,17.6-78.34-32.17,12.88-55.39,42.68-59.41,78.34Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m296.21,161.02c10.42,20.39,16.42,49.29,17.6,78.34h41.81c-4.01-35.66-27.24-65.46-59.41-78.34Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m260.69,154.03c-12.22,0-29.41,33.05-31.57,85.33h63.15c-2.16-52.29-19.35-85.33-31.57-85.33Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m165.77,260.69c4.01,35.66,27.24,65.46,59.41,78.34-10.42-20.39-16.42-49.29-17.6-78.34h-41.81Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m410.03,68.69h-21.33v-22.07c0-26.64-25.12-47.46-52.2-40.62l-227.57,62.93c-22.38,1.29-40.23,19.72-40.23,42.42v362.67c0,23.53,19.14,42.67,42.67,42.67h298.67c23.53,0,42.67-19.14,42.67-42.67V111.36c0-23.53-19.14-42.67-42.67-42.67Zm-68.05-42.07c12.45-3.18,25.39,6.91,25.39,20v22.07h-177.5l152.12-42.07Zm-27.95,426.07h-117.33c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h117.33c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm42.67-42.66h-202.67c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h202.67c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm-96-42.68c-64.7,0-117.33-52.64-117.33-117.33s52.64-117.33,117.33-117.33,117.33,52.63,117.33,117.33-52.64,117.33-117.33,117.33Z"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "m296.21,339.04c32.17-12.88,55.39-42.68,59.41-78.34h-41.81c-1.18,29.06-7.18,57.95-17.6,78.34Z"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rejsegarantiordning-btn__text" }, [
      _c("span", [_vm._v("Du er beskyttet af")]),
      _vm._v(" "),
      _c("span", [_vm._v("Rejsegarantiordningen")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ff0b162", { render: render, staticRenderFns: staticRenderFns })
  }
}